<template>
  <v-container fluid>
    <v-progress-linear v-if="loading" indeterminate color="deep-purple" />
    <h5 class="grey--text">Vista general</h5>
    <v-row>
        <v-col md="6">
            <h2 class="deep-purple--text lighten-3">
              {{$t('district_admins.all_district_admins')}}
            </h2>
        </v-col>
        <v-col md="6">
            <v-row justify="end" class="my-0 mr-4">
                <v-btn
                  text
                  small
                  color="deep-purple lighten-1"
                  @click.prevent="toggleCreateDistrictAdminModal()"
                >
                    <v-icon size="21" class="mr-1">
                    mdi-plus
                    </v-icon>
                    {{ $t('district_admins.create') }}
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
    <district-admins-filter v-model="params" @search="search(true)"></district-admins-filter>
    <district-admins-data-table
      :table-loading="loading"
      v-model="page"
      :items="districtAdmins"
      :length="totalPages"
      @edit="editDistrictAdmin"
      @refresh="handleRefresh"
    ></district-admins-data-table>
    <create-district-admin-modal
      v-model="isCreateDistrictAdminModalOpen"
      @onCancel="toggleCreateDistrictAdminModal"
      @onSave="handleDistrictAdminCreated"
    />
  </v-container>
</template>

<script>
import CreateDistrictAdminModal from '@/components/districtAdmins/modals/CreateDistrictAdminModal.vue';
import DistrictAdminsFilter from '../../components/core/filters/DistrictAdminsFilter.vue';
import DistrictAdminsDataTable from '../../components/districtAdmins/DistrictAdminsDataTable.vue';
import LoadingMixin from '../../mixins/loading';
import snackbarMixin from '../../mixins/snackbar';

import districtAdminService from '../../services/districtAdmin.service';
import { defaultDistrictAdminFilter } from '../../constants/filters';

export default {
  name: 'DistrictAdmins',
  components: {
    DistrictAdminsFilter,
    DistrictAdminsDataTable,
    CreateDistrictAdminModal,
  },
  data: () => ({
    page: 1,
    params: { ...defaultDistrictAdminFilter },
    isCreateDistrictAdminModalOpen: false,
  }),
  mixins: [LoadingMixin, snackbarMixin],
  computed: {
    districtAdmins() {
      return this.$store.state.districtAdmins;
    },
    totalPages() {
      return this.$store.state.districtAdminsTotalPages;
    },
  },
  mounted() {
    this.search(true);
  },
  methods: {
    toggleCreateDistrictAdminModal() {
      this.isCreateDistrictAdminModalOpen = !this.isCreateDistrictAdminModalOpen;
    },
    handleDistrictAdminCreated() {
      this.toggleCreateDistrictAdminModal();
      this.search(true);
      this.snackbarSuccess('Administrador de distrito creado exitosamente');
    },
    editDistrictAdmin(districtAdmin) {
      this.$router.push(`/edit/district-admins/${districtAdmin.id}`);
    },
    handleRefresh() {
      this.search(true);
    },
    async search(showLoading = false) {
      if (showLoading) {
        this.loader();
      }

      const queryParams = {
        page: this.page,
        ...this.params,
      };

      try {
        const response = await districtAdminService.getDistrictAdmins(queryParams);
        this.$store.commit('SET_DISTRICT_ADMINS', response.data.data);
        this.$store.commit('SET_DISTRICT_ADMINS_TOTAL_PAGES', response.data.total_page);
      } catch (error) {
        this.snackbarError('Error al cargar administradores de distrito');
      } finally {
        if (showLoading) {
          this.loader();
        }
      }
    },
  },
  watch: {
    page() {
      this.search();
    },
  },
};
</script>
